import React, { useState } from "react";
import { createPortal } from "react-dom";
import {
    CloseIcon,
    LuggageIcon,
    CabinIcon,
    ArrowRightIcon,
    FlightTopIcon,
    ChevronLeftIcon,
    CheckinIcon,
    LuggageIconNew,
} from "../../helper/HwIcon";
import { airlineImageFn } from "../../helper/commonFunction";
import "../flights/BookingDetailsComponent/flight.css";

function BaggageDetailsPopup({
    showBaggageDetailsModal,
    setShowBaggageDetailsModal,
    baggageDetailsPassengerData,
    bagggageDetailsFlightDetails,
    baggageDetailsFlightDetailsIndex,
    source,
    bookingId,
    flightShowErrorMessage,
    backtoSearchButtonFn,
    searchQuery = {},
    showBundleinclusion = false,
    setbundleInclusion,
}) {
    return createPortal(
        <>
            <div
                className={`hw-modal fbd-baggage-modal fade ${showBaggageDetailsModal ? "show" : ""} ${flightShowErrorMessage ? "error-modal" : ""}`}
                style={{
                    backgroundColor: flightShowErrorMessage && "rgba(0, 0, 0, 0.5)",
                }}
            >
                <div className="hw-modal-dialog hw-modal-dialog-centered hw-modal-dialog-scrollable">
                    <div className={`hw-modal-content`}>
                        <div className="hw-modal-header">
                            <div className="hw-modal-headerTitle">
                                {showBundleinclusion
                                    ? "Note"
                                    : flightShowErrorMessage
                                        ? "ALERT"
                                        : "Baggage Details"}
                            </div>
                            {!flightShowErrorMessage ? (
                                <button
                                    onClick={() => {
                                        setShowBaggageDetailsModal(false);
                                        setbundleInclusion(false);
                                    }}
                                    className="hw-modal--close"
                                >
                                    <CloseIcon />
                                </button>
                            ) : flightShowErrorMessage?.includes("includes") ? (
                                <button
                                    onClick={() => {
                                        setShowBaggageDetailsModal(false);
                                    }}
                                    className="hw-modal--close"
                                >
                                    <CloseIcon />
                                </button>
                            ) : (
                                <button
                                    onClick={backtoSearchButtonFn}
                                    className="hw-link hw-link--icon hw-modal--close"
                                >
                                    <ChevronLeftIcon />
                                    Back to Search
                                </button>
                            )}
                        </div>
                        <div className="hw-modal-body">
                            {flightShowErrorMessage ? (
                                <div className="d-flex align-items-center hw-gapy16 mb-2">
                                    <div
                                        className="d-flex align-items-center hw-gapy6"
                                        dangerouslySetInnerHTML={{ __html: flightShowErrorMessage }}
                                    ></div>
                                </div>
                            ) : (
                                <>
                                    <div className="d-flex align-items-center hw-gapy16 mb-24 fbd-bag-summary">
                                        <span className="hw-text14 d-flex hw-gapy10 hw-black hw-fontWeight--500">
                                            <img
                                                alt={bagggageDetailsFlightDetails?.airline?.name}
                                                width="40"
                                                height="40"
                                                src={airlineImageFn(
                                                    bagggageDetailsFlightDetails?.airline?.code,
                                                )}
                                            />
                                        </span>
                                        <div className="d-flex align-items-center hw-gapy6">
                                            <div className="hw-blue h4 mb-0">
                                                {bagggageDetailsFlightDetails?.departure?.airportCode}
                                            </div>
                                            <span className="hw-blue h4 mb-0">-</span>
                                            <div className="hw-blue h4 mb-0">
                                                {bagggageDetailsFlightDetails?.arrival?.airportCode}
                                            </div>
                                        </div>
                                        <span>
                                            <div className="d-flex align-items-center hw-text14 ">
                                                {bagggageDetailsFlightDetails?.airline?.code}-
                                                {bagggageDetailsFlightDetails?.flightNumber}
                                                {/*<div className="ms-2half">
                                                {source !== 'travel-fusion' && (<> <FlightTopIcon/>-{bagggageDetailsFlightDetails?.equipmentType}</>) }
                                            </div>*/}
                                            </div>
                                        </span>
                                    </div>
                                    <div className="hw-table--responsive">
                                        <table className="hw-table--border lr-borderNull xl-big hw-table--baggage">
                                            <thead>
                                                <tr>
                                                    <th>Baggage Type</th>
                                                    {source !== "air-arabia" &&
                                                        !(source === "travel-fusion" && bookingId) ? (
                                                        <th>
                                                            <div className="d-flex align-items-center hw-gapy6">
                                                                <span className="hw-primary">
                                                                    <CheckinIcon />
                                                                </span>
                                                                Check-In Baggage
                                                            </div>
                                                        </th>
                                                    ) : (
                                                        ""
                                                    )}
                                                    <th>
                                                        <div className="d-flex align-items-center hw-gapy6">
                                                            <span className="hw-primary">
                                                                <LuggageIconNew />
                                                            </span>
                                                            Cabin Baggage
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {source !== "air-arabia"
                                                    ? source === "travel-fusion" && bookingId
                                                        ? baggageDetailsPassengerData?.length &&
                                                        baggageDetailsPassengerData?.map(
                                                            (bagggeDetails) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td> {bagggeDetails?.passengerType}</td>
                                                                            <td>
                                                                                {" "}
                                                                                {bagggeDetails?.baggageInfo?.cabinBaggage}
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            },
                                                        )
                                                        : baggageDetailsPassengerData?.length &&
                                                        baggageDetailsPassengerData?.map(
                                                            (bagggeDetails) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td> {bagggeDetails?.passengerType}</td>
                                                                            <td>
                                                                                {bookingId
                                                                                    ? bagggeDetails?.baggageInfo?.includedBaggage
                                                                                    : ["tripjack", "akasa-air", "travel-fusion", "verteil", "ndc-portal", "aljazeera", "fly-dubai"].includes(source)
                                                                                        ? bagggeDetails?.baggageInfo?.includedBaggage || "N/A"
                                                                                        : source === "amadeus"
                                                                                            ? bagggeDetails?.legDetails?.[
                                                                                                baggageDetailsFlightDetailsIndex
                                                                                            ]?.baggageInfo?.checked
                                                                                            : "N/A"}
                                                                            </td>

                                                                            <td>
                                                                                {source === "aljazeera"
                                                                                    ? "7 KG"
                                                                                    : bookingId
                                                                                        ? bagggeDetails?.baggageInfo?.cabinBaggage
                                                                                        : ["tripjack", "akasa-air", "travel-fusion", "verteil", "ndc-portal", "fly-dubai"].includes(source)
                                                                                            ? bagggeDetails?.baggageInfo?.cabinBaggage || "N/A"
                                                                                            : source === "amadeus"
                                                                                                ? bagggeDetails?.legDetails?.[
                                                                                                    baggageDetailsFlightDetailsIndex
                                                                                                ]?.baggageInfo?.cabin
                                                                                                : "N/A"}
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            },
                                                        )
                                                    : searchQuery?.passengers
                                                        ? Object?.keys(searchQuery?.passengers)?.map(
                                                            (pass) => {
                                                                return (
                                                                    <tr>
                                                                        <td> {pass}</td>
                                                                        <td>10 Kg</td>
                                                                    </tr>
                                                                );
                                                            },
                                                        )
                                                        : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showBaggageDetailsModal && <div className="hw-modal-backdrop fade show" />}
        </>,
        document.body,
    );
}

export default BaggageDetailsPopup;
